const route = {
  workbench: '工作台',
  pointsRecord: '积分记录',
  aiSourcingLab: 'AI 搜寻实验室',
  beta: 'Beta',
  reportCenter: '报表中心',
  emailConfig: '邮箱配置',
  coldEmail: '冷邮件',
  inbox: '收件箱',
  contentManagement: '配置中心',
  recruitingAi: '招聘Agent',
  recruitingAiV2: '招聘Agent',
  newRecruitingConversation: '新建招聘',
  recruitingSection: '招聘',
  recruitingProjects: '招聘项目',
  recentConversations: '最近会话',
  platformSection: '平台',
  adminSection: '运营',
  resumeImportMonitor: '简历导入实时榜',
  recommendationReportPreview: '推荐报告预览',
  allTalents: '数据汇总',
  talentGroup: '人才库',
  jobsGroup: '岗位人才',
  jobList: '招聘项目',
  jobCreate: '新建岗位',
  jobCandidates: '岗位候选人',
  resumeParse: '简历解析导入',
  candidateGroups: '分组列表',
  pricing: '会员升级',
  referral: '推荐有礼',
  referralInvite: '好友邀请',
  settingsProfile: '账号设置',
  adminOrganizations: '企业组织管理',
  organization: '企业席位与权益',
}

export default route
